import type { JavascriptFeatureToggles } from 'autogen/swagger/all';

const featureTogglesObj: JavascriptFeatureToggles = {
    bookingAppVirtualEnabled: false,
    bookingEarlyStageEnabled: false,
    bookingEnabled: false,
    bookingVirtualEnabled: false,
    dawaAutocompleteEnabled: false,
    debugViewEnabled: false,
    findationEnabled: false,
    makeupAdvisorEnabled: false,
    pointAsDiscountEnabled: false,
    powerstepEnabled: false,
    virtualTryOnEnabled: false,
    visualSearchEnabled: false,
    onskeskyenEnabled: false,
    onskeskyenEnabledInApp: false,
    isKlarnaExpressEnabled: false,
    clickAndCollectEnabled: true,
    clickAndCollectDisplayOnBasket: true,
    clickAndCollectDisplayOnCheckout: true,
    clickAndCollectDisplayOnProductPage: true,
    clickAndCollectTimePromiseInLabelDesignEnabled: true,
    flowBoxEnabled: false,
    videolyEnabled: true,
    acceptCookies: true,
    disable3rdParty: false,
    isCookieInformationEnabled: true,
    isCOMAIEnabled: true
};

export const setFeatureToggles = (obj: JavascriptFeatureToggles) => {
    for (const item in obj) {
        featureTogglesObj[item] = obj[item];
    }
};

const FeatureToggles = () => featureTogglesObj;

export default FeatureToggles();
